import { render, staticRenderFns } from "./ApplyViewEditDetail.vue?vue&type=template&id=dafbab78&scoped=true"
import script from "./ApplyViewEditDetail.vue?vue&type=script&lang=js"
export * from "./ApplyViewEditDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplyViewEditDetail.vue?vue&type=style&index=0&id=dafbab78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafbab78",
  null
  
)

export default component.exports